import { Component, Input } from '@angular/core';

@Component({
    selector: 'not-found-feature',
    templateUrl: './not-found-feature.component.html',
    styleUrls: ['./not-found-feature.component.scss'],
    standalone: false
})
export class NotFoundFeatureComponent {
  @Input() featureName!: string;
}
